<template>
    <div class="col-lg-12">
        <div v-if="clienteStatus == 0 || clienteStatus == 2" class="mb-3">
            <div class="col-12 mb-3" style="padding:0">
                <label for="validationCustom01" class="active"> Teléfono </label>
                <input type="text" class="form-control" id="validationCustom01" placeholder="Teléfono" v-model="order.cliente.telefono" @change="clientesChange">
            </div>
            <div class="clientes-list mb-3" v-if="clientes.length > 0">
                <div v-for="(cliente, idx) in clientes" v-bind:key="idx+cliente.nombre">
                    <div class="row" @click="selectCliente(cliente)" style="padding:0 33px 0 15px; cursor: pointer;">
                        <div class="col-12 domicilio-container"> 
                            <div class="row">
                                <div class="col-10">
                                    <div class="domicilio-header"> {{ cliente.nombre }} - {{ cliente.telefono }} </div>
                                    <div class="domicilio-body"> {{ cliente.resDomicilio.calle }} # {{ cliente.resDomicilio.numeroExt }}, {{ cliente.resDomicilio.colonia }} </div>
                                </div>
                                <div class="col-2 select-container">
                                    <i class="fa fa-check-circle" v-if="cliente.clienteId == order.cliente.id"></i>        
                                    <i class="fa fa-circle-o" v-else></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="text-center">
                <p>No se han encontrado clientes.</p>
            </div>
            <div class="adp">
                <div v-if="clienteStatus == 2" class="btn-group" role="group" aria-label="Basic example">
                    <button class="btn btn-danger w-50">Eliminar</button>
                    <button class="btn btn-success w-50" @click="setClienteStatus(1)">Editar</button>
                </div>
                <button v-else class="btn btn-danger" @click="setClienteStatus(1)">Agregar</button>
            </div>
        </div>
        <div v-if="clienteStatus == 1" class="mb-3">
            <div class="form-row">
                <div class="col-md-4 mb-3">
                    <label for="validationCustom01" class="active"> Teléfono </label>
                    <input type="text" class="form-control" id="validationCustom01" placeholder="Teléfono" v-model="order.cliente.telefono">
                
                </div>
                <div class="col-md-8 mb-3">
                    <label for="validationCustom02" class="active">Nombre</label>
                    <input type="text" class="form-control" id="validationCustom02" placeholder="Nombre" v-model="order.cliente.nombre">

                </div>
            </div>
            <div class="form-row">
                <div class="col-md-4 mb-3">
                    <label for="validationCustom03" class="active">Calle</label>
                    <input v-model="order.domicilio.calle" type="text" class="form-control" id="validationCustom03" placeholder="City" required="">
                </div>
                <div class="col-md-4 mb-3">
                    <label for="validationCustom04" class="active">Colonia</label>
                    <input v-model="order.domicilio.colonia" type="text" class="form-control" id="validationCustom04" placeholder="State" required="">

                </div>
                <div class="col-md-2 mb-3">
                    <label for="validationCustom05" class="active">Num Ext</label>
                    <input v-model="order.domicilio.numExt" type="text" class="form-control" id="validationCustom05" placeholder="Ext" required="">

                </div>
                <div class="col-md-2 mb-3">
                    <label for="validationCustom05" class="active">Num Int</label>
                    <input v-model="order.domicilio.numInt" type="text" class="form-control" id="validationCustom08" placeholder="Int" required="">

                </div>
            </div>
            <div class="form-row">
                <div class="col-md-6 mb-3">
                    <label for="validationCustom01" class="active"> Entre calles </label>
                    <input v-model="order.domicilio.entreCalles" type="text" class="form-control" id="validationCustom01" placeholder="Calles..." >
                
                </div>
                <div class="col-md-6 mb-3">
                    <label for="validationCustom02" class="active">Referencia</label>
                    <input v-model="order.domicilio.referencia" type="text" class="form-control" id="validationCustom02" placeholder="Referencia..." >
                
                </div>
            </div>
            <div class="adp">
                <button v-if="order.cliente.id == -1" class="btn btn-danger" @click="setClienteStatus(0)">Cancelar</button>
                <button v-else class="btn btn-danger" @click="setClienteStatus(2)">Cancelar</button>
            </div>
        </div>
       
        <div class="input-group mb-3 pr-4" style="height:34px">
            <div class="input-group-prepend">
                <span class="input-group-text">Costo de Envío</span>
                <span class="input-group-text">$</span>
            </div>
            <input type="text" class="form-control" placeholder="" aria-describedby="basic-addon2" v-model="order.cobroEnvio">
            <div class="input-group-append">
                <span class="input-group-text">.00</span>
            </div>
        </div>
    </div>
</template>

<script>

import ResClientes from '@/modules/restaurant/models/ResClientes.js';

export default {
    name: 'Domicilio',
    props: {
        order: Object,
    },
    mounted(){
        if(this.order.cliente.telefono.length > 6){
            ResClientes.getClientes(this.order.cliente.telefono, this.actualizarClientes)
        }
    },
    data(){
        return {
            clienteStatus: 0,
            clientes: []
        }
    },
    methods: {
        setClienteStatus(status){
            this.clienteStatus = status
        },
        actualizarClientes(res){
            this.clientes = res.data.items
            console.log("clientes", this.clientes)
        },
        selectCliente(cliente){
            if(this.order.cliente.id == cliente.clienteId){
                this.unselectCliente()
                this.clienteStatus = 0
                return
            }

            this.order.cliente.id = cliente.clienteId
            this.order.cliente.nombre = cliente.nombre
            this.order.cliente.created = cliente.created
            this.order.cliente.rfc = cliente.rfc
            this.order.cliente.telefono = cliente.telefono

            this.order.domicilio.id = cliente.resDomicilio.domicilioId
            this.order.domicilio.calle = cliente.resDomicilio.calle
            this.order.domicilio.colonia = cliente.resDomicilio.colonia
            this.order.domicilio.numExt = cliente.resDomicilio.numeroExt
            this.order.domicilio.numInt = cliente.resDomicilio.numeroInt
            this.order.domicilio.entreCalles = cliente.resDomicilio.entreCalles
            this.order.domicilio.referencia = cliente.resDomicilio.referencia
            this.order.domicilio.deleted = false
            this.order.domicilio.created = cliente.resDomicilio.created
            this.order.domicilio.createdBy = cliente.resDomicilio.createdBy
            this.order.domicilio.clienteId = cliente.clienteId
            this.order.domicilio.apiClienteId = cliente.resDomicilio.apiClienteId

            this.clienteStatus = 2
        },
        clientesChange(){
            ResClientes.getClientes(this.order.cliente.telefono, this.actualizarClientes)
        },
        actualizarClientes(res){
            this.clientes = res.data.items
            console.log("clientes", this.clientes)
        },
        unselectCliente(){
            this.order.cliente = {
                id: -1,
                nombre: "",
                telefono: this.order.cliente.telefono
            }
            
            this.order.domicilio = {
                id: -1,
                calle: "",
                colonia: "",
                numExt:"",
                numInt:"",
                entreCalles:"",
                referencia:""
            }
        }
    },
}
</script>

<style>
.adp{
    margin-right: 18px !important;
}

.adp > *{
    width: 100%;
}

.select-container{
    text-align: center;
    font-size: 28px;
    color: rgb(238, 13, 51);
    padding-top: 1px;
}

.domicilio-container{
    padding-top: 3px;
    border-bottom: 1px solid rgb(192, 192, 192);
}

.domicilio-header{
    font-size: 14px;
    margin-bottom: 3px;
    font-weight: bold;
}

.domicilio-body{
    font-size: 12px;
    margin-bottom: 5px;
}
</style>